export const CALENDLY_URL = "https://calendly.com/growyourcontent/discoverycall";
export const EMAIL = "team@grow-co.net";
export const FOUNDER_HEADSHOT_URL = null; // [FOUNDER_HEADSHOT_URL] placeholder, not yet supplied
export const ANNIE_ELISE_ANALYTICS_IMAGE_URL = "/media/annie-photo.jpeg";
export const ANNIE_ELISE_HEADSHOT_URL = "/media/annie-photo.jpeg";
export const MANCHUREK_CASE_IMAGE = "/media/m_0ul6H1k-S00.jpg";
export const LIONHEART_CASE_IMAGE = "/media/l_-xrXYuAZbBM.jpg";
export const MANCHUREK_CHANNEL_URL = "https://www.youtube.com/@manchurektriplets";
export const LIONHEART_CHANNEL_URL = "https://www.youtube.com/@LionHeartFilmWorks";
export const SHORT_CLIPS = [
    { thumb: "/clips/clip1.jpg", views: "61.3M views", url: "https://www.youtube.com/shorts/fCYJo6XlpN8" },
    { thumb: "/clips/clip2.jpg", views: "3.7M views", url: "https://www.youtube.com/shorts/qd3bS_AN0Dc" },
    { thumb: "/clips/clip4.jpg", views: "37K views", url: "https://www.youtube.com/shorts/kvfUD9KWfYM" },
    { thumb: "/clips/clip5.jpg", views: "85.7K views", url: "https://www.youtube.com/shorts/FWOiE69-Zlc" },
    { thumb: "/clips/clip6.jpg", views: "127K views", url: "https://www.youtube.com/shorts/8VlfUdtReNs" },
];
export const BRAND_LOGOS = [
    { name: "Annie Elise", url: "/logos/annie-elise.jpg" },
    { name: "51 Insights", url: "/logos/51insights.jpg" },
    { name: "GMMCO", url: "/logos/gmmco.png" },
    { name: "GrowthSchool", url: "/logos/growthschool.jpg" },
    { name: "Straight Outta Health IT", url: "/logos/healthit.jpg" },
    { name: "LaFetch", url: "/logos/lafetch.png", light: true },
    { name: "Manchurek Triplets", url: "/logos/manchurek.jpg" },
    { name: "Hidden True Crime", url: "/logos/hiddentruecrime.jpg" },
    { name: "CKA Birla Group", url: "/logos/ckabirla.png" },
    { name: "Hungama OTT", url: "/logos/hungama.png", light: true },
];
export const POLICY_URLS = {
    terms: "/terms-and-conditions",
    privacy: "/privacy-policy",
    refund: "/cancellation-and-refund-policy",
    digital: "/digital-services-shipping-policy",
};
